
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_qpzv4_100",
  "wizard": "awsui_wizard_1xupv_qpzv4_135",
  "refresh": "awsui_refresh_1xupv_qpzv4_135",
  "small-container": "awsui_small-container_1xupv_qpzv4_142",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_1xupv_qpzv4_146",
  "navigation": "awsui_navigation_1xupv_qpzv4_154",
  "number": "awsui_number_1xupv_qpzv4_236",
  "circle": "awsui_circle_1xupv_qpzv4_252",
  "title": "awsui_title_1xupv_qpzv4_263",
  "active": "awsui_active_1xupv_qpzv4_294",
  "disabled": "awsui_disabled_1xupv_qpzv4_305",
  "enabled": "awsui_enabled_1xupv_qpzv4_315",
  "form": "awsui_form_1xupv_qpzv4_357",
  "form-header": "awsui_form-header_1xupv_qpzv4_362",
  "background": "awsui_background_1xupv_qpzv4_372",
  "form-header-content": "awsui_form-header-content_1xupv_qpzv4_384",
  "form-component": "awsui_form-component_1xupv_qpzv4_392",
  "hidden": "awsui_hidden_1xupv_qpzv4_406",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_qpzv4_410",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_qpzv4_415",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_qpzv4_419",
  "form-header-component": "awsui_form-header-component_1xupv_qpzv4_419",
  "navigation-link": "awsui_navigation-link_1xupv_qpzv4_435",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_qpzv4_436",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_qpzv4_437",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_qpzv4_441",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_qpzv4_446",
  "cancel-button": "awsui_cancel-button_1xupv_qpzv4_450",
  "previous-button": "awsui_previous-button_1xupv_qpzv4_451",
  "primary-button": "awsui_primary-button_1xupv_qpzv4_452",
  "skip-to-button": "awsui_skip-to-button_1xupv_qpzv4_453",
  "action-buttons": "awsui_action-buttons_1xupv_qpzv4_457"
};
  